
const arrayEqual = (arr1, arr2) => {
  if (arr1 === arr2) return true;
  if (arr1.length !== arr2.length) return false;
  for (let i = 0; i < arr1.length; i += 1) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
}

/**
 * 填空题计算正确的空格数
 */

const arraySame = (userAnswer, correctAnswer) => {
  let length = 0;
  userAnswer.forEach((item, index) => {
    const pattern = new RegExp('^(' + correctAnswer[index] + ')$'); // eslint-disable-line
    const correct = pattern.test(item);
    if (correct) length += 1;
  });
  return length;
}

/**
 * 新版雅思入学测评数据
 */
const config1 = {
  // key value 分别是 questionMaterialId 和 unitScore
  44708: 2,
  44709: 2,
  44710: 2,
  44711: 6,
  44712: 2,
  44713: 4,
  44714: 8,
  44715: 4,
  44716: 8 / 3,
  44718: 4,
  44719: 6,
  44717: 2,
  44720: 2,
  44721: 4,
  44722: 6,
  44723: 4,
  44724: 6,
  44725: 3,
  44726: 2,
  44727: 4,
  44728: 4,
  44729: 2,
  44730: 4 }

/**
  * 新版入学测评报告页 得分情况
  * 目前支持 配置子题单位分值
  * 填空题按照空格来计分 点选题全部答对才有分
  * 返回的结果是 正确率和等级
  */
export const handleAnswer = (data,
  config = config1) => {
  const { questions } = data.data.questionBackup;
  let testSocre = 0;
  let rank;
  let socre;
  questions.map(question => {
    const questionMaterials = question.materials;
    questionMaterials.map(material => {
      const unit = config[material.id];
      const uAnswer = material.userAnswer.answer || [];
      const { answer } = material;
      if (question.type === 'Blank' || question.type === 'subjectBlank') {
        testSocre += arraySame(uAnswer, answer) * unit;
      } else if (question.type === 'PointSelect' || question.type === 'SortPointSelect') {
        if (arrayEqual(uAnswer, answer)) testSocre += unit;
      } else if (material.userAnswer.correct) { testSocre += unit; }
      return false;
    });
    return false;
  });
  if (testSocre >= 84) {
    rank = '高级';
    socre = '5.5-6';
  } else if (testSocre >= 60 && testSocre < 84) {
    rank = '中级';
    socre = '4-5.5';
  } else {
    rank = '初级';
    socre = '4分以下';
  }
  return { testSocre, rank, socre };
};




// WEBPACK FOOTER //
// ./src/components/report/utils/handleReport.js